import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {
  getCurrencyEventSchedules,
  GetCurrencyEventSchedulesParams,
} from '../api';
import {QUERY__CURRENCY_EVENT_SCHEDULES} from '../queryKeys';
import {CurrencyEventSchedule} from '../types';

export const useGetCurrencyEventSchedules = <
  SelectedData = GetListOutput<CurrencyEventSchedule>,
>(
  params: GetCurrencyEventSchedulesParams,
  options?: QueryOptionsForList<CurrencyEventSchedule, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__CURRENCY_EVENT_SCHEDULES, params],
    queryFn: () => getCurrencyEventSchedules(params),
    ...options,
  });
};
